<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: activity.links.show,
                    },
                    {
                        name: $t('messages.assign_evaluation_value'),
                        href: null,
                    },
                ]"
            />
        </template>

        <Tabs class="mt-5">
            <Tab :title="$tc('messages.syllabus_contents', 2)" :selected="activity.selected === 'syllabus_contents'">
                <ActivitySyllabusContentsSelector
                    :categories="categories"
                    :activity="activity"
                    :grade-levels="grade_levels"
                    :new-syllabus-content-id="new_syllabus_content_id"
                />
            </Tab>

            <Tab
                :title="$tc('messages.competences', 2)"
                :selected="activity.selected === 'competences'"
                v-if="syllabus.competences_count"
            >
                <ActivityCompetencesSelector :categories="categories" :activity="activity" />
            </Tab>

            <Tab :title="$tc('messages.dimensions', 2)" :selected="activity.selected === 'dimensions'">
                <ActivityDimensionsSelector :categories="categories" :activity="activity" />
            </Tab>
        </Tabs>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import Tab from '@/components/Tab.vue';
import Tabs from '@/components/Tabs.vue';
import ActivityCompetencesSelector from '@/components/pageSpecific/Syllabus/ActivityCompetencesSelector.vue';
import ActivityDimensionsSelector from '@/components/pageSpecific/Syllabus/ActivityDimensionsSelector.vue';
import ActivitySyllabusContentsSelector from '@/components/pageSpecific/Syllabus/ActivitySyllabusContentsSelector.vue';

export default {
    components: {
        ActivityCompetencesSelector,
        ActivityDimensionsSelector,
        ActivitySyllabusContentsSelector,
        PanelPage,
        Tab,
        Tabs,
    },
    props: ['categories', 'activity', 'syllabus', 'meta', 'grade_levels', 'new_syllabus_content_id'],
    layout: Layout,
    data() {
        return {
            key_content_ids: this.activity.key_content_ids,
        };
    },
    name: 'Edit',
};
</script>
